export default function CsharpQuiz() {
  return (
    <h2>Csharp Quiz</h2>
  );
}
